import { API_METHODS } from '../../config/constants';

export const APPLICATION_ACTION_TYPES = {
  APPLICATION_SET_DATA_BY_KEY: 'APPLICATION_SET_DATA_BY_KEY',
  APPLICATION_CHANGE_PROCESSING: 'APPLICATION_CHANGE_PROCESSING',
  APPLICATION_CLEAR_STATE: 'APPLICATION_CLEAR_STATE',
};

export function setDataByKey(data, stateKeyForDataSaving) {
  return {
    type: APPLICATION_ACTION_TYPES.APPLICATION_SET_DATA_BY_KEY,
    payload: {
      data,
      stateKeyForDataSaving,
    },
  };
}

export function clearState(clearedKey, shouldDeleteProperty = false) {
  return {
    type: APPLICATION_ACTION_TYPES.APPLICATION_CLEAR_STATE,
    payload: {
      clearedKey,
      shouldDeleteProperty,
    },
  };
}

export function changeProcessingState(newState) {
  return {
    type: APPLICATION_ACTION_TYPES.APPLICATION_CHANGE_PROCESSING,
    payload: newState,
  };
}

export function getData(pageObject, stateKeyForDataSaving, methodUrl) {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();

    dispatch(changeProcessingState(true));

    const response = await axios.get(methodUrl);

    dispatch(changeProcessingState(false));

    if (!response || response.code !== 'success' || !pageObject.mounted) {
      return response;
    }

    const { data = {}, accessRequest } = response;
    dispatch(setDataByKey(data, stateKeyForDataSaving));

    if (accessRequest !== undefined) {
      dispatch(setDataByKey(accessRequest, 'accessRequest'));
    }

    return response;
  };
}

export function getApplicationVersion(stateKeyForDataSaving, methodUrl) {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();

    dispatch(changeProcessingState(true));

    const response = await axios.get(methodUrl);

    dispatch(changeProcessingState(false));

    if (!response || response.code !== 'success') {
      return response;
    }

    const { data } = response;

    dispatch(setDataByKey({ version: data }, stateKeyForDataSaving));

    return response;
  };
}

export function checkIsNeoplasms(pageObject, stateKeyForDataSaving, methodUrl) {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();

    dispatch(changeProcessingState(true));

    const response = await axios.get(methodUrl);

    dispatch(changeProcessingState(false));

    if (!response || response.code !== 'success' || !pageObject.mounted) {
      return response;
    }

    const { data } = response;

    dispatch(setDataByKey({ status: data }, stateKeyForDataSaving));

    return response;
  };
}

export function checkIsAdditionalContactsVisible(
  pageObject,
  stateKeyForDataSaving,
  applicationId,
  isSponsor,
  isActiveSponsor,
) {
  return async (dispatch, getState, { getAxios }) => {
    const axios = getAxios();

    dispatch(changeProcessingState(true));

    const request = axios
      .get(API_METHODS.APPLICATION_ID_ADDITIONAL_CONTACT_POINT(applicationId))
      .then((response) => ({
        ...response,
        data:
          !!response.data?.contacts?.length || (!isSponsor && !isActiveSponsor),
      }));

    const response = await request;

    dispatch(changeProcessingState(false));

    if (!response || response.code !== 'success' || !pageObject.mounted) {
      return response;
    }

    const { data } = response;

    dispatch(setDataByKey({ status: data }, stateKeyForDataSaving));

    return response;
  };
}

export function getApplicationDraft(stateKeyForDataSaving, methodUrl) {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();

    dispatch(changeProcessingState(true));

    const response = await axios.get(methodUrl);

    dispatch(changeProcessingState(false));

    if (!response || response.code !== 'success') {
      return response;
    }

    const { data = {} } = response;

    dispatch(setDataByKey(data, stateKeyForDataSaving));

    return response;
  };
}

export function setStatus(methodUrl, values) {
  return async (dispatch, getState, { getAxios, getListAxios }) => {
    const axios = getAxios();

    dispatch(changeProcessingState(true));

    const response = await axios.put(methodUrl, values);

    dispatch(changeProcessingState(false));

    // if (!response || response.code !== 'success') {
    //   return response;
    // }
    return response;
    // const { data = {}, accessRequest } = response;
    // dispatch(setDataByKey(data, stateKeyForDataSaving));
    //
    // if (accessRequest !== undefined) {
    //   dispatch(setDataByKey(accessRequest, 'accessRequest'));
    // }
    //
    // return response;
  };
}
